import Dexie from 'dexie';
import { ActionRecord, ConversationRecord, MessageRecord, SyncStoreFlexIndexInternal } from '../services/sync.types';
import { MediaBlob } from '../types';
import { BackgroundQueueRecord } from './background-queue.types';

export interface ConversationCategoryRecord {
    conv_id: string;
    category_id: string;
}

export interface UserCategorySubscriptionRecord {
    user_id: string;
    category_id: string;
}

export interface QueuedMediaBlobRecord {
    id?: number;      // Auto-incrementing primary key
    blob: Blob;
    filename: string; // The filename associated with this blob for the sendMulti operation
}

export class WHMessagingDB extends Dexie {
    conversations!: Dexie.Table<ConversationRecord, string>;
    messages!: Dexie.Table<MessageRecord, number>;
    pendingMediaMessages!: Dexie.Table<{ id?: number; url: string; message: MessageRecord }, number>;
    drafts!: Dexie.Table<{ conv_id: string, text: string, mediaBlobIds: number[] }, string>;
    draftMediaBlobs!: Dexie.Table<{ id?: number; blob: Blob, ext: string }, number>;
    pendingActions!: Dexie.Table<ActionRecord, number>;
    failedMessages!: Dexie.Table<{ id: string }, string>;
    sendingMessages!: Dexie.Table<{ id: string }, string>;
    meta!: Dexie.Table<{ key: string, value: any }, string>;
    flexMeta!: Dexie.Table<{ key: string, data: string }, string>;
    mediaBlobs!: Dexie.Table<MediaBlob, string>;
    mediaQueue!: Dexie.Table<{ url: string, failed: number }, string>;
    backgroundQueue!: Dexie.Table<BackgroundQueueRecord, number>;
    conversation_categories!: Dexie.Table<ConversationCategoryRecord, string>;
    user_category_subscriptions!: Dexie.Table<UserCategorySubscriptionRecord, [string, string]>;
    queuedMediaBlobs!: Dexie.Table<QueuedMediaBlobRecord, number>; // New table

    constructor(dbName: string) {
        super(dbName);
        this.version(1).stores({
            conversations: "id",
            messages: "++local_counter, conv_id, tmp_id, timestamp",
            pendingMediaMessages: "++id, url",
            drafts: "conv_id",
            draftMediaBlobs: "++id",
            pendingActions: "id",
            failedMessages: "id",
            sendingMessages: "id",
            meta: "key",
            flexMeta: "key",
            mediaBlobs: "url",
            mediaQueue: "url, failed",
            backgroundQueue: "++id",
            conversation_categories: "conv_id",
            user_category_subscriptions: "[user_id+category_id]",
            queuedMediaBlobs: "++id" // Added filename index if needed for querying, but id is primary
        });
    }

    async reset() {
        this.close();
        await Dexie.delete(this.name);
        await this.open();
    }
}